import { ReactComponent as Logo } from './logo/logo-bbwm.svg';
import { ReactComponent as NavLogo } from './logo/logo-silbar.svg';
import {
    aquaGradient,
    aquaGradientColors,
    blueGradient,
    blueGradientColors,
    GOLD,
    goldGradient,
    goldGradientColors,
    greyGradientColors,
    redGradient,
    redGradientColors,
    turquoiseGradient,
    turquoiseGradientColors
} from './colors/colors';
const palette = {
    themeGradient: {
        primary: GOLD[400],
        secondary: GOLD[400]
    },
    gradients: {
        primary: goldGradient,
        secondary: turquoiseGradient,
        info: blueGradient,
        error: redGradient,
        success: aquaGradient
    },
    gradientColors: {
        primary: goldGradientColors,
        secondary: greyGradientColors,
        success: aquaGradientColors,
        error: redGradientColors,
        info: blueGradientColors,
        warning: turquoiseGradientColors
    },
    primary: {
        lightest: GOLD[50],
        lighter: GOLD[200],
        light: GOLD[400],
        main: GOLD[500],
        dark: GOLD[600],
        shadow: GOLD[100],
        contrastText: '#fafafa',
        contrastGreyText: '#fff'
    },
    borderColor: GOLD[200],
    focusColor: GOLD[50],
    mainSelected: GOLD[100],
    dashboardGradients: [
        {
            start: goldGradientColors[0],
            end: goldGradientColors[1]
        },
        {
            start: aquaGradientColors[0],
            end: aquaGradientColors[1]
        },
        {
            start: redGradientColors[0],
            end: redGradientColors[1]
        },
        {
            start: blueGradientColors[0],
            end: blueGradientColors[1]
        },
        {
            start: turquoiseGradientColors[0],
            end: turquoiseGradientColors[1]
        }
    ],
    defaultDashboardGradient: {
        start: goldGradientColors[0],
        end: goldGradientColors[1]
    }
};

// wrap for svg
const LogoSvg = () => (
    <svg width="133" height="64" viewBox="0 0 133 64">
        <Logo />
    </svg>
);
const NavLogoSvg = () => (
    <svg width="133" height="64" viewBox="0 0 133 64">
        <NavLogo />
    </svg>
);
const config = {
    title: 'SillBar',
    logo: LogoSvg,
    navLogo: NavLogoSvg,
    palette,
    chartSettings: {
        hiddenFields: ['volumeTransactionsByDate']
    }
};

export default config;
